import React, { useState } from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading} from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { ReactComponent as ChevronDownIcon } from "feather-icons/dist/icons/chevron-down.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-7.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-8.svg";

 const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const Column = tw.div`flex flex-col items-center`;
const HeaderContent = tw.div``;

const FAQSContainer = tw.dl`mt-12 max-w-4xl relative`;
const FAQ = tw.div`cursor-pointer select-none mt-5 px-8 sm:px-10 py-5 sm:py-4 rounded-lg text-gray-900 hover:text-gray-900 bg-purple-200 hover:bg-gray-300 transition duration-300`;
const Question = tw.dt`flex justify-between items-center`;
const QuestionText = tw.span`text-lg lg:text-xl font-semibold`;
const QuestionToggleIcon = motion(styled.span`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`);
const Answer = motion(tw.dd`pointer-events-none text-sm sm:text-base leading-relaxed`);

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-56 w-56 opacity-15 transform translate-x-2/3 -translate-y-12 text-teal-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-64 w-64 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;



export default ({
  subheading = "",
  heading = "",
  description = "",
  faqs = [
    {
      question: "Wat is het verschil tussen een psycholoog en een GZ-psycholoog?",
      answer:"Wat is het verschil tussen een psycholoog en GZ-psycholoog? Een psycholoog heeft de universitaire studie psychologie afgerond en behandelt psychische problemen. Een GZ-psycholoog heeft na de universitaire studie een postdoctorale beroepsopleiding van twee jaar gevolgd. De GZ-psycholoog begeleidt de psycholoog, stelt diagnoses, en mag regie hebben over de behandeling (regiebehandelaar)."
      
    },
    {
      question: "Wanneer ga je naar een psycholoog?",
      answer:"Als je last hebt van mentale klachten die ervoor zorgen dat je vastloopt in het dagelijks leven is dat reden genoeg om hulp te zoeken bij een psycholoog. Een psycholoog kan daarnaast helpen bij het ‘vinden’ van een diagnose als jij en je huisarts daar vermoedens van hebben."

    },
    {
      question: "Met welke klachten kan ik terecht? ",
      answer:"Je kunt bij mij terecht voor vrijwel alle lichte tot matige psychische problematiek zoals stemmingsproblemen, paniek/angst, trauma, en ontwikkelingsproblematiek (zoals ADHD en ASS)."

    },
    {
      question: " Met welke klachten kan ik niet terecht en waarom?",
      answer:"Je kunt bij mij niet terecht als je een grote afhankelijkheid hebt aan een of meer middelen (verslavingsstoornis), psychotische klachten ervaart, een onbehandelde persoonlijkheidsstoornis hebt en/of andere ernstige psychische problematiek. Wanneer een of meerdere van deze zaken spelen is het beter om hulp te zoeken bij een gespecialiseerde instelling waar bijvoorbeeld ook een psychiater werkzaam is. "
      
    },
    {
      question: "Hoe maak ik een afspraak?",
      answer:"De huisarts kan je verwijzen naar een psycholoog door het opstellen van een verwijsbrief. Deze is nodig om de zorg vergoed te krijgen. De verwijsbrief komt via een digitaal systeem bij mij terecht. Vervolgens zal contact met je worden opgenomen om een kennismakingsgesprek in te plannen. Twijfel je over de aanmelding? Dan kan je contact met mij opnemen om de situatie te bespreken."
    },
    {
      question: "Hoe lang duurt een behandeling?",
       answer: "Binnen mijn praktijk steun ik het wetenschappelijk bewezen kortdurend behandelen. Zo snel mogelijk in je eigen kracht komen en het weer zelf gaan proberen. Dit betekent dat je meestal tussen de 10 en 14 sessies nodig hebt om aanzienlijk minder of vrijwel geen klachten meer te ervaren. Indien toch blijkt dat de gestelde diagnose onvoldoende behandeld is gaan we opnieuw met elkaar in gesprek. Ook kan dit betekenen dat je meer hulp nodig hebt dan ik je kan bieden zoals een gespecialiseerde instelling. "
    },
    {
      question: "Hoe lang duurt een onderzoek? ",
       answer: "Een onderzoek bestaat meestal uit drie tot vier afspraken van ongeveer 60 tot 90 minuten. Na het stellen van een eventuele diagnose beslissen we samen of je verdere behandeling wilt en zo ja waar je deze behandeling wilt volgen."
    },

    {
      question: "Kan ik in mijn dossier? ",
      answer:"Transparantie (beschikbaarheid over informatie) is belangrijk. Daarom maken we samen aan het eind van elke sessie een kort verslag van wat er besproken is en stellen we samen de brief op naar de huisarts. Ook heb je ten alle tijde inzage in jouw dossier."
      
    }
    
  ]
}) => {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
    else setActiveQuestionIndex(questionIndex);
  };

  return (
    <Container>
      <ContentWithPaddingXl>
        <Column>
          <HeaderContent>
            {/* {subheading && <Subheading>{subheading}</Subheading>} */}
            <Heading>Veel Gestelde Vragen</Heading>
            {description && <Description>{description}</Description>}
          </HeaderContent>
          <FAQSContainer>
            {faqs.map((faq, index) => (
              <FAQ
                key={index}
                onClick={() => {
                  toggleQuestion(index);
                }}
                className="group"
              >
                <Question>
                  <QuestionText>{faq.question}</QuestionText>
                  <QuestionToggleIcon
                    variants={{
                      collapsed: { rotate: 0 },
                      open: { rotate: -180 }
                    }}
                    initial="collapsed"
                    animate={activeQuestionIndex === index ? "open" : "collapsed"}
                    transition={{ duration: 0.02, ease: [0.04, 0.62, 0.23, 0.98] }}
                  >
                    <ChevronDownIcon />
                  </QuestionToggleIcon>
                </Question>
                <Answer
                  variants={{
                    open: { opacity: 1, height: "auto", marginTop: "16px" },
                    collapsed: { opacity: 0, height: 0, marginTop: "0px" }
                  }}
                  initial="collapsed"
                  animate={activeQuestionIndex === index ? "open" : "collapsed"}
                  transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                >
                  {faq.answer}
                </Answer>
              </FAQ>
            ))}
          </FAQSContainer>
        </Column>
      </ContentWithPaddingXl>
      <DecoratorBlob1/>
      <DecoratorBlob2 />
    </Container>
  );
};
